import React from 'react';

import { View } from '@amzn/stencil-react-components/layout';

import { Breadcrumbs } from '@amzn/stencil-react-components/breadcrumbs';
import { Link } from 'react-router-dom';
import { titleCase } from '../util/commonUtils';
import useBreadcrumbs from '../hooks/useBreadcrumbs';
import { PRIMARY_COLOR } from '../constants/attributes';

export const BreadcrumbsContainer = () => {
  const crumbs = useBreadcrumbs();
  const onCrumbRenderHandler = ({ title, url }) => {
    return (
      <Link
        to={url}
        style={{
          textDecoration: 'none',
          color: PRIMARY_COLOR,
        }}
        children={titleCase(title)}
      />
    );
  };

  return (
    <View backgroundColor="neutral0" width={'100%'}>
      <Breadcrumbs crumbs={crumbs} renderCrumbLink={onCrumbRenderHandler} />
    </View>
  );
};

export default BreadcrumbsContainer;
